import React, { useContext, useEffect, useState } from 'react';
import ModalContext from '../../../context/ModalContext';
import AuthContext from '../../../context/AuthContext';
import { Button, CircularProgress, Alert } from '@mui/material';

const MakeCouponLiveModal = ({ modalDetails }) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(modalDetails?.checkError ?? null);

  const { coupon, checkError } = modalDetails || {};

  useEffect(() => {
    if (checkError) setError(checkError);
  }, [checkError]);

  const closeHandle = () => {
    setError(null);
    modalCtx.closeModal();
  };

  const handleMakeLive = async () => {
    if (!coupon?.id) {
      setError('Coupon ID is required');
      return;
    }

    setError(null);
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URI}/v3/advertising/coupon/${coupon.id}/live`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      );

      const data = await response.json();

      if (data.status === 'success') {
        modalCtx.setPageUpdate({ page: 'CouponLeads', couponId: coupon.id });
        closeHandle();
      } else {
        setError(data.error || data.message || 'Failed to make coupon live');
      }
    } catch (err) {
      console.error('Error making coupon live:', err);
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-container">
      <div className="modal-header">
        <h1>Make Coupon Live</h1>
      </div>
      <div className="modal-body">
        {error && (
          <Alert severity="error" onClose={() => setError(null)} sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <span>Are you sure you want to make this coupon live?</span>
        <br />
        <span style={{ fontSize: '12px', color: '#555' }}>
          {coupon?.coupon ? (
            <>The coupon &quot;{coupon.coupon}&quot; will be made available to users on the app.</>
          ) : (
            <>This coupon will be made available to users on the app.</>
          )}
        </span>
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={loading}>
          CANCEL
        </Button>
        <Button onClick={handleMakeLive} disabled={loading}>
          {loading ? (
            <><CircularProgress size={16} style={{ color: '#fff', marginRight: 8 }} />Publishing...</>
          ) : 'Make Live'}
        </Button>
      </div>
    </div>
  );
};

export default MakeCouponLiveModal;

